import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfBasedatos, IConfBasedatosGenerales, IConfBasedatosResumen } from '@/modules/Administracion/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
export class BasedatosService extends BaseService<IConfBasedatos> {
  constructor () {
    super({
      baseUrl: 'system/databases/'
    })
  }
  async generales(): Promise<AxiosResponse<IResponseApi<IConfBasedatosGenerales>>> {
      return this.http.get<IResponseApi<IConfBasedatosGenerales>>(
        `/general`
      )
  }

  /**
   * Resumen estadístico de un cargue de base de datos (total, sexo y grupo etario).
   * Pasar `cocoId` para el último cargue de un contrato, o `cobdId` para uno específico.
   * Retorna `body: null` si el contrato/cargue no tiene datos.
   */
  async resumen (
    params: { cocoId?: number | string, cobdId?: number | string }
  ): Promise<AxiosResponse<IResponseApi<IConfBasedatosResumen | null>>> {
    return this.http
      .get<IResponseApi<IConfBasedatosResumen | null>>(`/resumen`, { params })
      .catch(this.errorHandle)
  }
}
